/** @jsx jsx */
import { Box, Container, Grid, jsx } from 'theme-ui'
import FooterLegal from '~/components/Footer/Legal'
import FooterLinks from '~/components/Footer/Links'
import FooterNewsletterSignup from '~/components/Footer/NewsletterSignup'
import FooterContact from '~/components/Footer/Contact'
import FooterCta from '~/components/Footer/Cta'
import FooterSocial from '~/components/Footer/Social'
import useFooterQuery from '~/hooks/graphql/queries/use-footer'

export const Footer = () => {
  const { links, legal } = useFooterQuery()

  return (
    <Box as="footer" role="contentinfo">
      <Box
        bg="brandPrimary"
        color="white"
        sx={{ pt: [6, 7, null, 9], pb: [7, null, null, 9] }}
      >
        <Container>
          <Grid columns={[1, 2, null, '2fr 1fr']} sx={{ rowGap: '0' }}>
            <Box>
              <FooterLinks sections={links.pages} />
            </Box>
            <Box>
              <Box sx={{ display: ['none', 'block', null, 'none'], mb: 5 }}>
                <FooterContact />
              </Box>
              <Box sx={{ display: ['none', 'block', null, 'none'], mb: 6 }}>
                <FooterSocial />
              </Box>
              <Box mb={[5, null, 7]}>
                <FooterNewsletterSignup />
              </Box>
              <Box
                pt={[4, null, 6]}
                sx={{
                  borderTop: '1px solid',
                  borderTopColor: 'white',
                }}
              >
                <FooterCta />
              </Box>
            </Box>
          </Grid>
        </Container>
      </Box>
      <Box
        bg="brandPrimaryDark"
        sx={{
          pb: [6, 4, 5],
          pt: [5, 4, 5],
          position: 'relative',
          zIndex: '91',
        }}
      >
        <Container>
          <FooterLegal links={legal.pages} />
        </Container>
      </Box>
    </Box>
  )
}

export default Footer
